export default __webpack_public_path__ + "static/media/img_top_1.44d3eece.webp";